import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJSON from './local/en.json'
import zhJSON from './local/zh.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enJSON },
      zh: { translation: zhJSON },
    },
    lng: "en",
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n; 